import {
  BookingAppointmentConfirmation,
  TestDriveRequestConfirmation,
  TimeSlotInterval,
} from '../../../graphql/schema';
import { TestDriveDay } from '../../../models/entities/calendar.model';
import ScheduledTestDrivesState from '../../../models/store/modules/scheduled-test-drives-state.model';

export const mutations = {
  testDriveBookingsCalendar(
    state: ScheduledTestDrivesState,
    payload: TestDriveDay[]
  ): void {
    state.testDriveBookingsCalendar = payload;
  },
  testDriveBookingsTimeSlots(
    state: ScheduledTestDrivesState,
    payload: TimeSlotInterval[]
  ): void {
    state.testDriveBookingsTimeSlots = payload;
  },
  userTestDriveBookings(
    state: ScheduledTestDrivesState,
    payload: BookingAppointmentConfirmation[]
  ): void {
    state.userTestDriveBookings = payload;
  },
  userTestDriveRequests(
    state: ScheduledTestDrivesState,
    payload: TestDriveRequestConfirmation[]
  ): void {
    state.userTestDriveRequests = payload;
  },
};
